export const devname = {
  device_name: "device_name",
};

export default devname;
